import { Tabs } from "../Tabs/Tabs"
import { TabContent } from "../Tab/TabContent"
import { NewOrders } from "../NewOrders/NewOrders"
import { Supplies } from "../Supplies/Supplies"
import { UpdateStoksIcon } from "../UpdateStoksIcon/UpdateStoksIcon"
import { Settings } from "../Settings/Settings"
import { UpdateStoksKatren } from "../UpdateStoksKatren/UpdateStoksKatren"
import { FC, useEffect, useMemo, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import { UpdateStoksPodruzhka } from "../UpdateStoksPodrugka/UpdateStoksPodruzhka"
import {
  selectActiveShops,
  selectShopName,
  SHOP_IDENT,
  updateSettingsState,
  updateShopName,
} from "../../app/reducers/settingsReducer"
import { UpdateStoksMetro } from "../UpdateStoksMetro/UpdateStoksMetro"
import { getOrdersState } from "../../app/reducers/ordersReducer"
import { useNavigate, useParams } from "react-router-dom"
import {
  subscribeChangedThunk,
  unsubscribeChangedThunk,
} from "../../app/services/ws/subscribeThunk"
import { UpdateStocksSamson } from "../Samson/UpdateStocks/UpdateStocksSamson"
import {
  selectFeedShopsStore,
  updateFeedShopsState,
} from "../../app/reducers/feedShopsSlice"
import { getMessage } from "../../msgs/msgs"
import { FeedShop } from "../FeedShop/FeedShop"
import { ShopComponent } from "../ShopComponent/ShopComponent"
import {
  selectShopsStore,
  updateShopsState,
} from "../../app/reducers/shopsSlice"
import { WBTokenGuard } from "../WBTokenGuard/WBTokenGuard"
import { WbAnalytics } from "../Analytics/WbAnalytics"
import { updateContentState } from "../../app/reducers/contentSlice"

export const Home: FC = () => {
  const { activeTab } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(getOrdersState())
    dispatch(updateSettingsState())
    dispatch(updateFeedShopsState())
    dispatch(subscribeChangedThunk())
    dispatch(updateShopsState())
    dispatch(updateContentState())
    return () => {
      dispatch(unsubscribeChangedThunk())
    }
  }, [dispatch])

  const activeShops = useAppSelector(selectActiveShops)
  const feedShops = useAppSelector(selectFeedShopsStore)
  const shops = useAppSelector(selectShopsStore)
  const shopName = useAppSelector(selectShopName)
  const [editingName, setEditingName] = useState(false)
  const [nameInput, setNameInput] = useState(shopName || "")

  useEffect(() => {
    if (!editingName) setNameInput(shopName)
  }, [shopName, editingName])

  useEffect(() => {
    document.title = shopName ? `${shopName} — Siqeel` : "Siqeel"
  }, [shopName])

  // Первый идентификатор из соответствующей группы магазинов, присутствующий
  // в activeShops. Используется чтобы не показывать дублирующие табы для
  // сгруппированных магазинов (KATREN/KATREN_OZON/KATREN_YANDEX и т.п.).
  const katrenIdent = useMemo(
    () =>
      (activeShops || []).find(
        (s) =>
          s === SHOP_IDENT.KATREN ||
          s === SHOP_IDENT.KATREN_OZON ||
          s === SHOP_IDENT.KATREN_YANDEX,
      ),
    [activeShops],
  )
  const samsonIdent = useMemo(
    () =>
      (activeShops || []).find(
        (s) => s === SHOP_IDENT.SAMSON || s === SHOP_IDENT.SAMSON_YANDEX,
      ),
    [activeShops],
  )
  const shopComponents: any[] = (activeShops || [])
    .map((shopName) => {
      switch (shopName) {
        case SHOP_IDENT.KATREN:
        case SHOP_IDENT.KATREN_OZON:
        case SHOP_IDENT.KATREN_YANDEX:
          if (shopName !== katrenIdent) return null
          return (
            <TabContent
              key={shopName}
              name={"Обновить остатки Katren"}
              ident={"katren"}
            >
              <UpdateStoksKatren />
            </TabContent>
          )
        case SHOP_IDENT.ICON:
          return (
            <TabContent
              key={shopName}
              name={"Обновить остатки ICON"}
              ident={"icon"}
            >
              <UpdateStoksIcon />
            </TabContent>
          )
        case SHOP_IDENT.PODRUZHKA:
          return (
            <TabContent
              key={shopName}
              name={"Обновить остатки Подружка"}
              ident={"podruzhka"}
            >
              <UpdateStoksPodruzhka />
            </TabContent>
          )
        case SHOP_IDENT.METRO:
          return (
            <TabContent
              key={shopName}
              name={"Обновить остатки Metro"}
              ident={"metro"}
            >
              <UpdateStoksMetro />
            </TabContent>
          )
        case SHOP_IDENT.SAMSON:
        case SHOP_IDENT.SAMSON_YANDEX:
          if (shopName !== samsonIdent) return null
          return (
            <TabContent
              key={shopName}
              name={"Обновить остатки Samson"}
              ident={"samson"}
            >
              <UpdateStocksSamson />
            </TabContent>
          )
        default:
          const shopInfo = shopName && shops?.[shopName]
          if (!shopInfo) return null

          return (
            <TabContent
              key={shopName}
              name={getMessage(shopName)}
              ident={(shopName as string).toLowerCase()}
            >
              <WBTokenGuard>
                <ShopComponent ident={shopName} shopInfo={shopInfo} />
              </WBTokenGuard>
            </TabContent>
          )
      }
    })
    .filter(Boolean)

  Object.keys(feedShops).forEach((shopIdent) => {
    shopComponents.push(
      <TabContent
        key={shopIdent}
        name={getMessage(shopIdent)}
        ident={shopIdent}
      >
        <WBTokenGuard>
          <FeedShop ident={shopIdent} />
        </WBTokenGuard>
      </TabContent>,
    )
  })

  return (
    <div className="homePage">
      {editingName ? (
        <form
          className="SHOP_NAME"
          onSubmit={(e) => {
            e.preventDefault()
            dispatch(updateShopName(nameInput))
            setEditingName(false)
          }}
        >
          <input
            autoFocus
            value={nameInput}
            onChange={(e) => setNameInput(e.target.value)}
            onBlur={() => {
              dispatch(updateShopName(nameInput))
              setEditingName(false)
            }}
            style={{
              font: "inherit",
              background: "transparent",
              border: "none",
              outline: "1px solid currentColor",
              padding: "0 4px",
            }}
          />
        </form>
      ) : (
        <div
          className="SHOP_NAME"
          title="Нажмите для редактирования"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setEditingName(true)
          }}
        >
          {nameInput || "МАГАЗИН"}
        </div>
      )}
      <Tabs
        activeTabIdent={activeTab}
        onChange={(ident) => navigate(`/${ident}`)}
        height="calc(100vh - 24px)"
      >
        {/* <TabContent name={"Поиск по артикулам"}>
          <Info />
        </TabContent> */}
        {/* <TabContent name={"Загрузка карточек"}>
          <Upload />
        </TabContent>
        <TabContent name={"Обновить остатки Katren Old"}>
          <UpdateStoksOld />
        </TabContent>
        */}
        {...shopComponents}
        <TabContent name={"Сборочные задания"} ident={"orders"} key={"orders"}>
          <NewOrders />
        </TabContent>
        <TabContent name={"Поставки"} ident={"supplies"} key={"supplies"}>
          <WBTokenGuard>
            <Supplies />
          </WBTokenGuard>
        </TabContent>
        <TabContent name={"Аналитика"} ident={"analytics"} key={"analytics"}>
          <WbAnalytics />
        </TabContent>
        <TabContent name={"Настройки"} ident={"settings"} key={"settings"}>
          <Settings />
        </TabContent>
      </Tabs>
    </div>
  )
}
